module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/cities/cities-show/cities-show.component.scss
// module id = ./src/app/views/setting/cities/cities-show/cities-show.component.scss
// module chunks = main